import { AppState } from './app';
import * as constants from '../constants';

// We type the payload cast inside each switch case:
export type SujetActionType = {
  type:
    | typeof constants.GET_ORDER_COMPANY
    | typeof constants.GET_CREATION_ORDER
    | typeof constants.GET_PRODUCTION_ORDER
    | typeof constants.GET_CAMPAIGNS
    | typeof constants.FETCHED_CAMPAIGN;

  payload: any;
};

export const sujetReducer = (state: AppState, action: SujetActionType) => {
  switch (action.type) {
    case constants.GET_ORDER_COMPANY: {
      const orderCompanyObj = {};
      action.payload.data.forEach((order) => {
        orderCompanyObj[order.number] = order;
      });
      return {
        ...state,
        orderCompanies: orderCompanyObj,
        orderCompaniesArray: action.payload.data,
      };
    }

    case constants.GET_CREATION_ORDER: {
      return {
        ...state,
        creationDetails: action.payload.data,
      };
    }

    case constants.GET_PRODUCTION_ORDER: {
      return {
        ...state,
        productionDetails: action.payload.data,
      };
    }

    case constants.GET_CAMPAIGNS: {
      const campaignsObjs = {};
      action.payload.data.forEach((campaign) => {
        campaignsObjs[campaign.number] = campaign;
      });

      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          campaigns: action.payload.data,
          campaignsObjs: { ...campaignsObjs },
        },
      };
    }

    case constants.FETCHED_CAMPAIGN: {
      const campaignsObjs = {};
      campaignsObjs[action.payload.data.campaigndata.number] = action.payload.data;

      return {
        ...state,
        campaignDetails: {
          ...state.campaignDetails,
          ...campaignsObjs,
        },
      };
    }
  }
};
